export default __webpack_public_path__ + "static/media/TerraceTemplateImage.36adccb9.jpg";